export abstract class TrackingService {
  abstract logAction(actionId: string): void
  abstract logNavigation(url: string, description: string, asiakasAvain: string | null, kirjanpitajaUid: string): void
}
